import React from "react";
import ReservationBuilderAvailableAccommodations from "../ReservationBuilderAvailableAccommodations";
import ReservationBuilderSegments from "../ReservationBuilderSegments";
import Tabs from "../../Tabs/Tabs";
import ReservationBuilderActions from "../actions/ReservationBuilderActions";


export default class ReservationBuilderAccommodationsStep extends React.Component {
  constructor(props) {
    super(props);

    this.onChangeActiveAccommodationsTab = this.onChangeActiveAccommodationsTab.bind(this); 
  }

  render() {
    
    return (
      <div>
        <div className="row accomidations-row">
          <div className="col-md-6">
            <div className="panel panel-default">
              <div className="panel-body container">
                <h3 className="panel-heading-text">{I18n.t('available_accommodations')}</h3>
                <div className="table-wrap-panel">
                  <Tabs tabs={this.accommodationsTabs()} />
                  <br className="embedded-table-tabs-br" />
                  {this.props.type_of_booking == "nightly" ? <ReservationBuilderAvailableAccommodations {...this.props} /> : null }
                  {this.props.type_of_booking == "daily" ? <ReservationBuilderAvailableAccommodations {...this.props} /> : null }
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 reservation-builder-segments-container">
            <ReservationBuilderSegments {...this.props} />
          </div>
        </div>
      </div>
    );
  }

  onChangeActiveAccommodationsTab(tab) {
    if (tab) {
      ReservationBuilderActions.changeTypeOfBooking(tab)
    }
  }

  accommodationsTabs() {
    var accommodationsTabs = [ 
      {
        tabName: I18n.t('nightly'),
        targetName: 'nightly',
        classes: this.props.type_of_booking === 'nightly' ? 'active' : null,
        changeHandler: this.onChangeActiveAccommodationsTab,
      },
   ];
    
    if (this.props.show_daily_rentals && this.props.show_daily_rentals != 'false') {   
      accommodationsTabs = [
        {
          tabName: I18n.t('nightly'),
          targetName: 'nightly',
          classes: this.props.type_of_booking === 'nightly' ? 'active' : null,
          changeHandler: this.onChangeActiveAccommodationsTab,
        },
        {
          tabName: I18n.t('daily'),
          targetName: 'daily',
          classes: this.props.type_of_booking === 'daily' ? 'active' : null,
          changeHandler: this.onChangeActiveAccommodationsTab,
        }
      ];
    }
    
    return (accommodationsTabs)
  };
}
